import React, {useState, useEffect} from 'react';
import {VisDiv, TextField, FieldDropdown } from '..';
import {deviceAndNonConfId, deviceSubstitutionStatus, euro, percentage, sortByOrder} from '../../lib/utils'; 
import { IoIosEye, IoIosEyeOff} from 'react-icons/io';
import RichTextEditor from '../RichTextEditor';
import {FiSave } from 'react-icons/fi'
import { deviceNonConformityDoc, generatedOfferWithTotalsDoc } from '../gestioneDatabase/Docs';
import { RiInsertRowTop } from "react-icons/ri";
import { isGodMode } from '../../lib/userPermissions';
import { useStateContext } from '../../context/StateContext';
import TestButton from '../frontend_components/TestButton';
import nonConformity from '../../sanity_ecommerce/schemas/nonConformity';
import deadlines from '../Deadlines';

/**
 * A single line of a product table, with the product name, unit price, discounted unit price, price to client, and total cost.
 * #offers #labourProducts
 * @param {object} data - An object containing the product data.
 * @param {object} data.pr - The product data.
 * @param {number} data.index - The index of the product in the array.
 * @param {object} data.commonStyle - The styles of the table.
 * @param {object} data.edit - Whether the product is being edited.
 * @param {object} data.offer - The offer data.
 * @param {object} data.updatedOffer - The updated offer data.
 * @param {function} data.updateDataArray - A function to update the array of product data.
 * @param {array} data.dataArray - The array of product data.
 * @param {object} data.screenSizeDesktop - The screen size of the desktop.
 * @param {object} data.register - The register data.
 * @param {object} data.registerTemplate - The register template data.
 * @param {array} data.nonConformities - The array of non conformity data.
 * @return {JSX.Element} - A JSX element representing a single line of a product table.
 */
export const EditableProduct = ({data}) => {

    const {pr, index, commonStyle, edit, offer, updatedOffer, updateDataArray, dataArray, screenSizeDesktop, register, registerTemplate, nonConformities} = data

    const {sUser, client } = useStateContext()
    //const product = generatedOfferWithTotalsDoc(offer?.offerFields?.find?.((x)=>x?._id == pr?._id))
    const product = generatedOfferWithTotalsDoc(pr)
    //const productInOfferFields = !Array.isArray(offer?.offerFields) ? undefined : offer?.offerFields?.find?.((x)=>x?._id == pr?._id)

/*     useEffect(()=>{
     if(productInOfferFields?.hide !== product?.hide){
       
       if(productInOfferFields?.hide) {
        console.log("ldmalkdmklas product in offer changed and hide is true, hiding line", {productInOfferFields, product})
         hideLine()
       }
       if(!productInOfferFields?.hide) {
        console.log("dpokqpkdqowpdk product in offer changed and hide is false, showing line", {productInOfferFields, product})
         showLine()
       }
     }
    },[productInOfferFields]) */

    const [unit, setUnit] = useState()
    const [deviceNonConformity, setDeviceNonConformity] = useState()
    const rowColour = index % 2 ? "#FFECBA":"#FFF6DE"

    useEffect(()=>{ setUnit( product?.unit? product?.unit : "1")},[product?.unit])

    const showLine = () => {
  
      const visibleDoc = (doc) => ({...doc, hide: false})
      //console.log("SHOW LINE", product, offer)
      //setIsEditingOffer(true)
      const updatedData = [...!Array.isArray(dataArray) ? [] : dataArray?.filter?.(x=>x?._id !== product?._id), visibleDoc(product) ]?.sort(sortByOrder)
      updateDataArray(updatedData)      
      const updatedOfferDoc = {...offer, offerFields:[...!Array.isArray(offer?.offerFields) ? [] : offer?.offerFields?.filter?.((x)=>x?._id !== product?._id), visibleDoc(product) ]}
      updatedOffer(updatedOfferDoc)
    }
    const hideLine = (e) => {
      e?.stopPropagation()
      const hiddenDoc = (item) => ({...item, hide: true})
      console.log("HIDE LINE", product)
      const updatedData = [...!Array.isArray(dataArray) ? [] : dataArray?.filter?.(x=>x?._id !== product?._id), hiddenDoc(product) ]?.sort(sortByOrder)
      console.log("UPDATED DATA", updatedData)
      updateDataArray(updatedData)
      const updatedOfferDoc = {...offer, offerFields:[...!Array.isArray(offer?.offerFields) ? [] : offer?.offerFields?.filter?.((x)=>x?._id !== product?._id), hiddenDoc(product) ]}
      updatedOffer(updatedOfferDoc)
    }
    const editProduct = (e) => {
      e?.stopPropagation()
      const newUnitDoc = (item) => (generatedOfferWithTotalsDoc({
        ...item,  
        deviceNonConformityId: deviceNonConformity?._id ? deviceNonConformity?._id : item?.deviceNonConformityId, 
        nonConformity : deviceNonConformity?.nonConformity?.label ? deviceNonConformity?.nonConformity?.label : item?.nonConformity,
        nonConformityId : deviceNonConformity?.nonConformity?._id ? deviceNonConformity?.nonConformity?.label : item?._id,
        quantity: Number(unit) ? Number(unit) : 1, unit: unit ? unit : "1" }
      ))
      console.log("EDIT UNIT", newUnitDoc(product))
      const updatedData = [...!Array.isArray(dataArray) ? [] : dataArray?.filter?.(x=>x?._id !== product?._id), newUnitDoc(product) ]?.sort(sortByOrder)
      console.log("UPDATED DATA", updatedData)
      updateDataArray(updatedData)
      const updatedOfferDoc = {...offer, offerFields:[...!Array.isArray(offer?.offerFields) ? [] : offer?.offerFields?.filter?.((x)=>x?._id !== product?._id), newUnitDoc(product) ]}
      updatedOffer(updatedOfferDoc, true)
    }
    const devices = !Array.isArray(register?.devices) ? [] : register?.devices
    const device = devices?.find((x)=>x?._id == product?.deviceId)

    //=======
    //#deadlines
    const deviceDeadlines = deadlines(device, registerTemplate)

    const findSupplyNonConformity = !Array.isArray(nonConformities) ? undefined : nonConformities
        ?.find?.((x)=>x?.registers?.some((y)=>register?.template?._ref == y?._ref) && x?.supply)
    const maintenanceNonConformities =  deviceDeadlines?.data
    const maintenanceDeviceNonConformities = !Array.isArray(maintenanceNonConformities) ? [] : maintenanceNonConformities?.map((item)=>{
        const doc = {...deviceNonConformityDoc(item?._id), _id: deviceAndNonConfId(device?._id, item?._id)}
        return doc 
      })
    const isThereSubDeadline = !Array.isArray(maintenanceNonConformities) ? false : maintenanceNonConformities?.some((x)=>x?.substitution)
    const subStatus = deviceSubstitutionStatus({deviceStatus: device?.status, device: device, deadlines: deviceDeadlines, client})
    
    const supplyDeviceNonConformity = () => {
      if(device?.status !== "DA FORNIRE") return
      if(!findSupplyNonConformity) return
      const doc = {...deviceNonConformityDoc(findSupplyNonConformity?._id), _id: deviceAndNonConfId(device?._id, findSupplyNonConformity?._id) }
      //if(!doc?._id) return
      return doc
    }
    const subDeviceNonConformities = () => {
      // FOUND THE SUB AND MAINTENANACE NON CONFORMITIES, maintenanceNonConformities, now implement subs
      if(!isThereSubDeadline && subStatus == "DA SOSTITUIRE") {
        const daSostituireNonConf = nonConformities?.find((x)=> x?._id == "5a6de70d-8353-4209-8eb9-cb62f5554d4a")
        const doc = {...deviceNonConformityDoc(daSostituireNonConf?._id), _id: deviceAndNonConfId(device?._id, daSostituireNonConf?._id) }
        return [...maintenanceDeviceNonConformities, doc]
      }
      return [...maintenanceDeviceNonConformities]
    } 
    const subSupplyDeviceNonConformities = [
      supplyDeviceNonConformity() ? supplyDeviceNonConformity() : undefined,
      ...subDeviceNonConformities() 
    ]?.filter?.((x)=>x)
    const allDeviceNonConformities = [...!Array.isArray(device?.nonConformities) ? [] : device?.nonConformities, ...subSupplyDeviceNonConformities]

    //========
    

    const deviceNonConformitiesExpanded = !Array.isArray(allDeviceNonConformities) ? [] : allDeviceNonConformities
      ?.map((dNc => {
        const nonConformity = !Array.isArray(nonConformities) ? [] : nonConformities?.find((x)=>x?._id == dNc?.nonConformity?._ref)
        return ({...dNc, nonConformity, label: nonConformity?.label, value: dNc?._id})
      }))
    const consoleData = {
      product, device, deviceNonConformitiesExpanded, pr, offer,
      prInOfferFields: !Array.isArray(offer?.offerFields) ? undefined : offer?.offerFields?.find?.((x)=>x?._id == pr?._id)
    }
    return (
      <div key={index} style={{backgroundColor:product?.hide ? "#C0C0C0" : rowColour, marginLeft:"35px", marginBottom:"5px", color:"#324d67"}} >
        <TestButton buttonId="wkdnkwdnkjwdnkdje" message={"TEST PRODUCT LINE"} consoleData={consoleData} />
        <VisDiv style={{zValue:1000, marginTop:"10px", color:"#324d67", display:"flex", alignItems:"center"}}>
        <p style={{color:"#324d67", marginRight:"5px", marginLeft:"10px"}}>Quantità e Non Conformità:</p>
        <TextField 
            //onBlur={()=> setDoc({...unitDoc, unit: Number(unitDoc?.unit)})}
            style={{maxWidth: "400px", marginTop:"20px"}}
            value={unit} 
            onChange={(e) => {
                console.log("UNITA' NO POSITION")
                setUnit(e.target.value)
            }} 
            type={"text"}
        />
          <VisDiv rules={[true]}>
        
                <FieldDropdown
                  isMulti={false}
                  isSearchable="isSearchable"
                  initialValue={deviceNonConformitiesExpanded?.find((x)=>x?.nonConformity?._id == product?.nonConformityId)}
                  placeHolder={"ASSEGNA A NON CONFORMITA'"}
                  options={deviceNonConformitiesExpanded?.filter((x)=>x?.status !== "ARCHIVIATO" && x?.status !== "COMPLETATO")}
                  onChange={(value) => {
                    setDeviceNonConformity(value)
                  }
                  } 
              />
          </VisDiv>
        <button type='button' className='round-back-button' style={{backgroundColor:"green", marginLeft:"10px"}} onClick={editProduct}>
            <FiSave            
            size={15}
            color={"white"}/>
        </button>
        </VisDiv>
    <VisDiv style={{display:"flex", alignItems:"center"}}>
        <VisDiv style={{color:"darkBlue", cursor:"pointer", marginLeft:"10px"}}>
            <VisDiv className='round-back-button' style={{backgroundColor:"grey"}} rules={[product?.hide]} onClick={(e) => {showLine()}}>
                <IoIosEyeOff fontSize={20} color='white'/>
            </VisDiv>
            <VisDiv className='round-back-button' style={{backgroundColor:"green"}} rules={[!product?.hide]} onClick={(e) => {hideLine(e)}}>
                <IoIosEye fontSize={20} color='white' />
            </VisDiv>
            <VisDiv rules={[false]}><button onClick={consoleData}>testProductLine</button></VisDiv>
        </VisDiv>
        <VisDiv style={{color:"darkBlue", marginLeft:"10px"}} rules={[product?.addedLocation]}>
        <RiInsertRowTop fontSize={25} color='grey'/>
        </VisDiv>
    </VisDiv>
      <div style={{display:"flex", marginBottom:"5px"}}>
        <div style={{...commonStyle(edit), textAlign:"center"}}>
          {product?.pricelistCode}
        </div>
        <div style={{...commonStyle(edit), flex:6, justifyContent:"left", minWidth: "185px"}}>
          <RichTextEditor existingDoc={product?.law} readOnly={true}/>
        </div>
        <div style={{...commonStyle(edit), flex:6, justifyContent:"left", minWidth: "185px"}}>
          <RichTextEditor existingDoc={product?.description} readOnly={true}/>
        </div>
        <div style={{...commonStyle(edit), flex:1.2, minWidth: "85px"}}>
          <span>
          {product?.location}
          </span>
        </div>
        <div style={{...commonStyle(edit)}}>
          {product?.quantity}
        </div>
        <div style={{...commonStyle(edit)}}>
          {euro(product?.unitPrice)}
        </div>
        <div style={{...commonStyle(edit)}}>
          {percentage(product?.discount)}
        </div>
        <div style={{...commonStyle(edit)}}>
          {euro(product?.discountedUnitPrice)}
        </div>
        <div style={{...commonStyle(edit)}}>
          {euro(product?.priceToClient)}
        </div>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle(edit)}}>
          {euro(product?.supplierPrice)}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle(edit)}}>
          {euro(product?.totalCost)}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop, false]}  style={{...commonStyle(edit)}}>
          {product?.labourHours}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle(edit)}}>
          {percentage(product?.margin)}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle(edit)}}>
          {euro(product?.profit)}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle(edit)}}>
          {euro(product?.unitProfit)}
        </VisDiv>
      </div>

  </div>
    )
}

/**
 * ViewProduct renders a single product in the offer with all relevant information
 * @param {{data, commonStyle}} props
 * @param {{pr, index=0, screenSizeDesktop, viewFullLaw}} data - props containing the product to render, its index, and whether to show the full law
 * @param {{commonStyle}} commonStyle - props containing common CSS styles for the component
 * @returns {JSX.Element} - a component that renders a single product in the offer with all relevant information
 */
export const ViewProduct = ({data, commonStyle}) => {

    const {pr, index=0, screenSizeDesktop, viewFullLaw} = data
    const {sUser } = useStateContext()
    //const product = generatedOfferWithTotalsDoc(offer?.offerFields?.find?.((x)=>x?._id == pr?._id))
    const product = generatedOfferWithTotalsDoc(pr)

    const rowColour = index % 2 ? "#FFECBA":"#FFF6DE"

    const testProductLine = (e) => {
      e?.stopPropagation()
      console.log("testProductLine slòcwlc,", {product })
      //console.log("testProductLine", product, "in offer", offer?.offerFields?.find?.((x)=>x?._id == product?._id), "addedLocations", offer?.offerFields?.filter?.((x)=>x?.addedLocation))
      //console.log("offer", offer?.offerFields?.find?.((x)=>x?._id == "88cb10ac-6afd-4558-848b-78ee07fde9f3"))
    }
    return (
      <div onClick={(e)=>testProductLine(e)} key={index} style={{backgroundColor:product?.hide ? "#C0C0C0" : rowColour, marginBottom:"5px", color:"#324d67"}} >
      <TestButton buttonId={"lmqlkmkmcccql"} message="testProductLine" consoleData={{product}} />
    <VisDiv style={{display:"flex", alignItems:"center"}}>
        <VisDiv style={{color:"darkBlue", cursor:"pointer", marginLeft:"10px"}}>
            <VisDiv rules={[false]}><button onClick={testProductLine}>testProductLine</button></VisDiv>
        </VisDiv>
    </VisDiv>
      <div style={{display:"flex", marginBottom:"5px"}}>
        <div style={{...commonStyle(), textAlign:"center"}}>
          {product?.pricelistCode}
        </div>
        <VisDiv rules={[viewFullLaw]} style={{...commonStyle(), flex:6, justifyContent:"left", minWidth: "185px"}}>
          <RichTextEditor existingDoc={product?.law} readOnly={true}/>
        </VisDiv>
        <VisDiv rules={[!viewFullLaw]} style={{...commonStyle(), flex:6, justifyContent:"left", minWidth: "185px"}}>
          {product?.lawLabel}
        </VisDiv>
        <div style={{...commonStyle(), flex:6, justifyContent:"left", minWidth: "185px"}}>
          <RichTextEditor existingDoc={product?.description} readOnly={true}/>
        </div>
        <div style={{...commonStyle(), flex:1.2, minWidth: "85px"}}>
          <span>
          {product?.location}
          </span>
        </div>
        <div style={{...commonStyle()}}>
          {product?.quantity}
        </div>
        <div style={{...commonStyle()}}>
          {euro(product?.unitPrice)}
        </div>
        <div style={{...commonStyle()}}>
          {percentage(product?.discount)}
        </div>
        <div style={{...commonStyle()}}>
          {euro(product?.discountedUnitPrice)}
        </div>
        <div style={{...commonStyle()}}>
          {euro(product?.priceToClient)}
        </div>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle()}}>
          {euro(product?.supplierPrice)}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle()}}>
          {euro(product?.totalCost)}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop, false]}  style={{...commonStyle()}}>
          {product?.labourHours}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle()}}>
          {percentage(product?.margin)}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle()}}>
          {euro(product?.profit)}
        </VisDiv>
        <VisDiv rules={[screenSizeDesktop]} style={{...commonStyle()}}>
          {euro(product?.unitProfit)}
        </VisDiv>
      </div>

  </div>
    )
}